import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { RiArrowDropDownFill } from "react-icons/ri";
import { CgMathMinus, CgMathPlus } from "react-icons/cg";
import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import { useUser } from "../../../context/user-context";
import { darkNoTransaction, noTransaction } from "../../../assets/images";
import ClipLoader from "react-spinners/ClipLoader";
import { BiMessageSquareAdd } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const SelectCardValue = ({
  setOpenSelectCard,
  setOpenSelectCardValue,
  setOpenGiftcardPreview,
  cardName,
  cardImg,
  card,
  setDenominationData,
  denominationData,
}: any) => {
  const { userDetails, theme, refetch } = useUser();
  const [bankName, setBankName] = useState<string>("");
  const [bankNumber, setBankNumber] = useState<string>("");
  const [openBank, setOpenBank] = useState<boolean>(false);
  const [openRangeAdd, setOpenRangeAdd] = useState<boolean>(false);
  const [openDenomination, setOpenDenomination] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [selectedCards, setSelectedCards] = useState<any[]>([]);
  const [amount, setAmount] = useState<string>("");
  const [singleSelectedCard, setSingleSelectedCard] = useState<any>({});
  const axiosInstance = useAuthAxios();
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
  const navigate = useNavigate();
  const [bankId, setBankId] = useState<string>("");

  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });

  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error2 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });

  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2]);
  const makeDefault = async ({ accountNumber, bankCode }: any) => {
    const response = await axiosInstance.put(API.makeDefaultBank(bankId), {
      accountNumber,
      bankCode,
    });
    return response.data;
  };

  const completeMakeDefault = useMutation({
    mutationFn: makeDefault,
    onSuccess: (r) => {
      toast.success(r.message);
      refetch();
      setLoadingIndex(null);
      setTimeout(() => {
        setOpenBank(false);
      }, 1000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
      setLoadingIndex(null);
    },
  });
  //  useEffect(() => {
  //    // Check for banks with `is_default` set to true
  //    const filteredBanks = userDetails?.user?.banks.filter((bank: any) => bank.is_default);
  //    // Set the banks with `is_default: true` to state
  //    if (filteredBanks && filteredBanks.length > 0) {
  //      setSelectedBankDetails(filteredBanks[0]);
  //    }
  //  }, [userBanks]);

  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setAmount(value);
    } else {
      setAmount("");
    }
  };

  const handleAddCard = (card: any) => {
    const newCard = { ...card, amount: Number(amount), numberOfCards: 1 }; // Initialize numberOfCards to 0
    setSelectedCards([...selectedCards, newCard]);
    setOpenRangeAdd(false);
  };

  const handleCardChange = (index: number, delta: number, card: any = null) => {
    if (card) {
      setSingleSelectedCard((prev: any) => ({
        ...prev,
        [index]: {
          ...card,
          amount: card.range.min,
          numberOfCards: Math.max(
            (prev?.[index]?.numberOfCards ?? 0) + delta,
            0
          ),
        },
      }));
    } else {
      setSelectedCards((prev) =>
        prev
          .map((card, i) =>
            i === index
              ? { ...card, numberOfCards: card.numberOfCards + delta }
              : card
          )
          .filter((card) => card.numberOfCards > 0)
      );
    }
  };
  const totalNairaValue = [
    ...selectedCards,
    ...Object.values(singleSelectedCard),
  ].reduce(
    (total, card) => total + card.amount * card.numberOfCards * card.rate,
    0
  );

  const totalDollarValue = [
    ...selectedCards,
    ...Object.values(singleSelectedCard),
  ].reduce((total, card) => total + card.amount * card.numberOfCards, 0);
  const validateInput = (cardV: any, min: any, max: any) => {
    if (cardV < min || cardV > max) {
      setError(`Value must be between ${min} and ${max}`);
      setTimeout(() => {
        setError("");
      }, 2000);
      return false;
    }
    setError("");
    return true;
  };
  const handleSave = (card: any) => {
    if (!validateInput(amount, card.range.min, card.range.max)) {
      return;
    }
    handleAddCard(card);
  };
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenSelectCardValue(false);
              setOpenSelectCard(true);
              setDenominationData([]);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100  font-sora font-semibold text-[20px]">
            Sell Giftcard
          </h4>
        </div>
        <div className="mt-8 w-full">
          <div className="w-full flex justify-start items-center gap-3 mt-4">
            <div className="h-[44px] w-[44px] ">
              <img
                src={cardImg}
                className="h-full w-full bg-cover rounded-full"
                alt=""
              />
            </div>
            <h4 className=" text-secondary_button font-semibold text-[20px]">
              {cardName}
            </h4>
          </div>
          <div className="mt-8 w-full relative">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Select Card Value
            </h4>
            <div
              onClick={() => {
                setOpenDenomination(true);
              }}
              className="w-full cursor-pointer border-gray-300 dark:border-gray-600 h-[48px] rounded-xl mt-2 border px-2 flex justify-between items-center text-gray-700 dark:text-gray-300"
            >
              <div className="flex w-[90%] justify-start items-center gap-3">
                <div className="text-[12px] w-full">
                  {denominationData.length >= 1 ? (
                    <div className="w-full  flex justify-start items-center gap-2 overflow-x-auto">
                      {denominationData.map((data: any, index: number) => (
                        <div
                          key={index}
                          className="p-1 text-[11px] flex justify-center items-center bg-[#D4EBFD] dark:bg-secondary_button/20 text-gray-700 dark:text-gray-200 font-medium rounded-lg"
                        >
                          ${data.amount} x{data.numberOfCards}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span className="text-gray-500 dark:text-gray-400">
                      Select card denomination
                    </span>
                  )}
                </div>
              </div>
              <RiArrowDropDownFill className="text-[28px] text-gray-700 dark:text-gray-300 shrink-0" />
            </div>
            {openDenomination && (
              <div className="absolute z-50 rounded-xl w-full mt-2 p-3 pt-2 border border-gray-200 bg-white dark:border-gray-600 dark:bg-[#1C2227] shadow-lg">
                <div className="h-[400px] pb-5 overflow-auto">
                  <h4 className="text-[16px] font-bold text-gray-700 dark:text-gray-300">
                    Total card value: $
                    {totalDollarValue.toLocaleString("en-US")}
                  </h4>
                  <h4 className="text-[12px] font-medium text-secondary_button">
                    Naira equivalent: {totalNairaValue.toLocaleString("en-US")}{" "}
                    NGN
                  </h4>
                  {card.map((ratee: any, index: any) => (
                    <div key={index} className="w-full">
                      <div className="w-full py-4 border-b border-gray-200 dark:border-gray-600 justify-between flex items-center">
                        <div>
                          <div
                            onClick={() => {
                              if (ratee.range.min !== ratee.range.max) {
                                setOpenRangeAdd(true);
                              }
                            }}
                            className="flex cursor-pointer items-center gap-1"
                          >
                            <h4 className="text-[15px] font-semibold text-gray-900 dark:text-gray-100">
                              {ratee.range.min === ratee.range.max
                                ? `$${ratee.range.min}`
                                : `$${ratee.range.min} - $${ratee.range.max}`}
                            </h4>
                            {ratee.range.min !== ratee.range.max && (
                              <RiArrowDropDownFill className="text-[20px] text-gray-900 dark:text-gray-100" />
                            )}
                          </div>
                          <h4 className="text-[12px] text-gray-500 dark:text-gray-400">
                            {ratee.rate} NGN/USD
                          </h4>
                        </div>
                        {ratee.range.min === ratee.range.max && (
                          <div className="flex items-center gap-4">
                            <div
                              className="flex justify-center bg-gray-100 dark:bg-gray-700 items-center p-2 rounded-lg cursor-pointer"
                              onClick={() => handleCardChange(index, -1, ratee)}
                            >
                              <CgMathMinus className="text-[16px] text-gray-900 dark:text-gray-100" />
                            </div>
                            <h4 className="text-[18px] text-gray-900 dark:text-gray-100">
                              {singleSelectedCard?.[index]?.numberOfCards ?? 0}
                            </h4>
                            <div
                              className="flex justify-center bg-gray-100 dark:bg-gray-700 items-center p-2 rounded-lg cursor-pointer"
                              onClick={() => handleCardChange(index, 1, ratee)}
                            >
                              <CgMathPlus className="text-[16px] text-gray-900 dark:text-gray-100" />
                            </div>
                          </div>
                        )}
                      </div>
                      {selectedCards.length >= 1 &&
                      ratee.range.min !== ratee.range.max
                        ? selectedCards.map((card, indexx) => (
                            <div
                              key={indexx}
                              className="w-full py-4 pl-4 mt-2 border-l-4 border-secondary_button justify-between flex items-center"
                            >
                              <div>
                                <div className="flex cursor-pointer items-center gap-1">
                                  <h4 className="text-[15px] font-semibold text-gray-900 dark:text-gray-100">
                                    ${card.amount}
                                  </h4>
                                </div>
                                <h4 className="text-[12px] text-gray-500 dark:text-gray-400">
                                  {ratee.rate} NGN/USD
                                </h4>
                              </div>
                              <div className="flex items-center gap-4">
                                <div
                                  className="flex justify-center bg-gray-100 dark:bg-gray-700 items-center p-2 rounded-lg cursor-pointer"
                                  onClick={() => handleCardChange(indexx, -1)}
                                >
                                  <CgMathMinus className="text-[14px] text-gray-900 dark:text-gray-100" />
                                </div>
                                <h4 className="text-[14px] text-gray-900 dark:text-gray-100">
                                  {card.numberOfCards}
                                </h4>
                                <div
                                  className="flex justify-center bg-gray-100 dark:bg-gray-700 items-center p-2 rounded-lg cursor-pointer"
                                  onClick={() => handleCardChange(indexx, 1)}
                                >
                                  <CgMathPlus className="text-[14px] text-gray-900 dark:text-gray-100" />
                                </div>
                              </div>
                            </div>
                          ))
                        : null}
                      {openRangeAdd && ratee.range.min !== ratee.range.max ? (
                        <div className="w-full mt-4">
                          <h4 className="text-[13px] font-medium text-gray-600 dark:text-gray-400">
                            Type Amount
                          </h4>
                          <input
                            type="text"
                            value={amount}
                            onChange={handleChange}
                            className="mt-2 px-3 text-[13px] border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#13181B] w-full spin-button-none outline-none focus:border-secondary_button text-gray-900 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 h-[48px] rounded-xl"
                          />
                          {error && (
                            <h4 className="text-red-500 text-[11px] mt-1 font-medium ">
                              {error}
                            </h4>
                          )}
                          <div className="flex w-full mt-4 gap-4 justify-between items-center">
                            <button
                              onClick={() => setOpenRangeAdd(false)}
                              className="border-secondary_button border flex justify-center items-center text-secondary_button text-[15px] font-medium h-[48px] w-full rounded-xl"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => handleSave(ratee)}
                              className="bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => {
                    setDenominationData([
                      ...selectedCards,
                      ...Object.values(singleSelectedCard),
                    ]);
                    setOpenDenomination(false);
                  }}
                  className="bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
                >
                  Done
                </button>
              </div>
            )}
          </div>
          <div className="mt-8 w-full relative">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Select Destination
            </h4>
            <div
              onClick={() => {
                setOpenBank((prev) => !prev);
              }}
              className="w-full cursor-pointer border-gray-300 dark:border-gray-600 h-[48px] rounded-xl mt-2 border px-2 flex justify-between items-center text-gray-700 dark:text-gray-300"
            >
              <div className="flex justify-start items-center gap-3">
                <h4
                  className={`text-[14px] ${
                    bankNumber && bankName
                      ? "text-gray-700 dark:text-gray-300"
                      : "text-gray-500 dark:text-gray-400"
                  }`}
                >
                  {bankNumber && bankName
                    ? `${bankNumber} - ${bankName}`
                    : "Select bank account"}
                </h4>
              </div>
              <RiArrowDropDownFill className="text-[28px] text-gray-700 dark:text-gray-300 shrink-0" />
            </div>
            {openBank && (
              <div className="absolute z-50 rounded-xl w-full mt-2 p-3 h-[250px] border border-gray-200 dark:border-gray-600 dark:bg-[#1C2227] overflow-auto bg-white shadow-lg">
                {userDetails?.user?.banks.length >= 1 ? (
                  <div className="w-full">
                    {userDetails.user.banks
                      .sort((a: any, b: any) => b.isDefault - a.isDefault)
                      .map((bank: any, index: number) => {
                        const matchedBank =
                          allBanks?.data.find(
                            (allBank: any) => allBank.bankCode === bank.bankCode
                          ) ||
                          allOldBanks?.data.find(
                            (newBank: any) => newBank.code === bank.bankCode
                          );

                        return (
                          <div
                            key={index}
                            onClick={() => {
                              if (bank.isDefault) {
                                setBankNumber(bank.accountNumber);
                                setBankName(
                                  matchedBank?.bankName || matchedBank?.name
                                );
                                setOpenBank(false);
                              } else {
                                setBankId(bank._id);
                                setLoadingIndex(index);
                                setTimeout(() => {
                                  completeMakeDefault.mutate({
                                    accountNumber: bank.accountNumber,
                                    bankCode: bank.bankCode,
                                  });
                                  setBankNumber(bank.accountNumber);
                                  setBankName(
                                    matchedBank?.bankName || matchedBank?.name
                                  );
                                }, 500);
                              }
                            }}
                            className={`w-full cursor-pointer flex justify-start items-center gap-4 p-4 ${
                              bank.isDefault
                                ? "border border-secondary_button rounded-xl"
                                : "border-b border-gray-200 dark:border-gray-600"
                            }`}
                          >
                            {loadingIndex === index ? (
                              <ClipLoader color="#5E91FF" size={20} />
                            ) : (
                              <div
                                className={`w-[20px] h-[20px] p-1 flex justify-center items-center rounded-full border ${
                                  bank.isDefault
                                    ? "border-secondary_button"
                                    : "bg-transparent border-[#505050]"
                                }`}
                              >
                                <div
                                  className={`w-full h-full rounded-full ${
                                    bank.isDefault
                                      ? "bg-secondary_button"
                                      : "bg-transparent"
                                  }`}
                                />
                              </div>
                            )}
                            <div>
                              <h4 className="text-[10px] font-bold text-gray-700 dark:text-gray-200">
                                {bank.accountName}
                              </h4>
                              <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
                                {bank.accountNumber} -{" "}
                                {matchedBank?.bankName ||
                                  matchedBank?.name ||
                                  "Unknown Bank"}
                              </h4>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <button
                    onClick={() => navigate("/settings")}
                    className="p-3 text-[14px] mt-8 mds:mt-0 transition ease-out duration-300 rounded-xl bg-secondary_button text-white gap-4 flex justify-center items-center"
                  >
                    <h4>Add bank</h4>
                    <BiMessageSquareAdd className="text-2xl" />
                  </button>
                )}
              </div>
            )}
          </div>
          <button
            disabled={!bankName || !bankNumber || denominationData.length < 1}
            onClick={() => {
              setOpenSelectCardValue(false);
              setOpenGiftcardPreview(true);
            }}
            className={
              !bankName || !bankNumber || denominationData.length < 1
                ? "mt-8 bg-gray-400 dark:bg-gray-600 flex justify-center items-center text-gray-100 dark:text-gray-400 text-[15px] font-medium h-[48px] w-full rounded-xl"
                : "mt-8 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
            }
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectCardValue;
